import { faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { viewAdmin } from "../../redux/features/admin/adminSlice";

function ViewAdmin({ adminId }) {
  const dispatch = useDispatch();
  const { selectedAdmin, viewAdminLoading } = useSelector(
    (state) => state.admin,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    roles: "",
    brand: "",
  });
  const handleOpen = () => {
    setIsModalOpen(true);
    dispatch(viewAdmin(adminId));
  };
  const handleClose = () => setIsModalOpen(false);

  useEffect(() => {
    if (selectedAdmin) {
      const { id, name, email, brand, roles } = selectedAdmin;
      setFormData({ id, name, email, brand, roles });
    }
  }, [selectedAdmin]);

  return (
    <div>
      <button
        onClick={handleOpen}
        className="text-blue-500 hover:text-blue-700 font-medium"
      >
        <FontAwesomeIcon icon={faEye} />
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[45%] p-10 relative">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h2 className="text-xl font-semibold border-b border-gray-200 mb-6 pb-5 text-left">
              View Admin
            </h2>

            {viewAdminLoading ? (
              <div className="text-center py-10 text-gray-500 font-medium text-2xl animate-pulse">
                Loading...
              </div>
            ) : (
              <form className="space-y-10">
                <div className="grid grid-cols-2 gap-5">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-gray-700 font-medium mb-1 text-left"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      readOnly
                      className="w-full border border-gray-300 rounded-md p-2 bg-gray-100 cursor-not-allowed"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="email"
                      className="block text-gray-700 font-medium mb-1 text-left"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      readOnly
                      className="w-full border border-gray-300 rounded-md p-2 bg-gray-100 cursor-not-allowed"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="roles"
                      className="block text-gray-700 font-medium mb-1 text-left"
                    >
                      Role
                    </label>
                    <input
                      type="roles"
                      id="roles"
                      name="roles"
                      value={formData.roles?.[0]?.name || ""}
                      readOnly
                      className="w-full border border-gray-300 rounded-md p-2 bg-gray-100 cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="brand"
                      className="block text-gray-700 font-medium mb-1 text-left"
                    >
                      Brand
                    </label>
                    <input
                      type="brand"
                      id="brand"
                      name="brand"
                      value={formData.brand?.name || ""}
                      readOnly
                      className="w-full border border-gray-300 rounded-md p-2 bg-gray-100 cursor-not-allowed"
                    />
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    type="button"
                    onClick={handleClose}
                    className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
                  >
                    Close
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
export default ViewAdmin;
